import { MedicalExamCertificateWaiver } from './medical-exam-certificate-waiver.model';
import { MedicalExamCertificateExemption } from './medical-exam-certificate-exemption.model';

export class MedicalExamCertificateRestriction {
    public restrictionId: number;
    public restrictionTypeId: number;
    public waivers: MedicalExamCertificateWaiver[];
    public exemptions: MedicalExamCertificateExemption[];
    public effectiveDate: Date;
    public endDate: Date;
    public active: boolean;
}
